<template>
    <div>   <a-drawer
            :title='title'
            :visible="visible"
            v-bind="drawerConfig"
            :body-style="{ paddingBottom: '80px' }"
            @close="onClose"
            class="box"
    >
        <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout">
          <a-form-model-item
              ref="name"
              label="模块名称"
              prop="name"
              :help="formErr.name"
              :validateStatus='!formErr.name||formErr.name==""?"":"error"'
          >
            <a-input :maxLength=50
                     v-model="form.name"
                     @change="(e) => { formErr.name=''}"
                     @blur="(e) => {  form.name = e.target.value.trim(); }"
            />
          </a-form-model-item>
            <a-form-model-item
                    ref="a_ksh_module_category_id"
                    label="分类"
                    prop="a_ksh_module_category_id"
                    :help="formErr.a_ksh_module_category_id"
                    :validateStatus='!formErr.a_ksh_module_category_id||formErr.a_ksh_module_category_id==""?"":"error"'
            >
<!--              {{form.a_ksh_module_category_id}}-->
<!--              <a-cascader v-model="form.a_ksh_module_category_id" :options="category_list" :fieldNames="fieldNames" placeholder="" />-->
              <a-select v-model="form.a_ksh_module_category_id" placeholder="请选择" allowClear>
              <a-select-option :value="item.id" :key="item.id" v-for="item in category_list">
                {{item.name}}
              </a-select-option>
              </a-select>
            </a-form-model-item>
          <a-form-model-item
              ref="source"
              label="来源"
              prop="source"
              :extra="formErr.source"
              :validateStatus='!formErr.source||formErr.source==""?"":"error"'
          >
            <a-radio-group v-model="form.source"  @change="changeSource" :disabled="form.id?true:false">
              <a-radio :value="item.id" :key="item.id" v-for="(item,index) in source_list"> {{item.name}} </a-radio>
            </a-radio-group>
          </a-form-model-item>
          <template >
          <a-form-model-item v-if="form.source==1"
              ref="code_name"
              label="代码中名称"
              prop="code_name"
              :help="formErr.code_name"
              :validateStatus='!formErr.code_name||formErr.code_name==""?"":"error"'
          >
            <a-input :maxLength=50
                     v-model="form.code_name"
                     @change="(e) => { formErr.code_name=''}"
                     @blur="(e) => {  form.code_name = e.target.value.trim(); }"
            />
          </a-form-model-item>
<!--          <a-form-model-item-->
<!--                    ref="option"-->
<!--                    label="配置文件"-->
<!--                    prop="option"-->
<!--                    :help="formErr.option"-->
<!--                    :validateStatus='!formErr.option||formErr.option==""?"":"error"'-->
<!--            >-->
<!--                <a-textarea  :rows="4" v-model="form.option"-->
<!--                              @change="(e) => { formErr.option=''}"-->
<!--                              @blur="(e) => {  form.option = e.target.value.trim() }"/>-->
<!--            </a-form-model-item>-->
          <a-form-model-item v-if="form.source==1||(form.source==2&&form.id)"
                    ref="picture"
                    label="图片"
                    prop="picture"
                    :extra="formErr.picture"
                    :validateStatus='!formErr.picture||formErr.picture==""?"":"error"'
            >
                <a-upload
                        :action="this.$store.state.urlChang"
                        :data="{type:3}"
                        :file-list="fileList"
                        :headers="headers"
                        @change="(file)=>{handleChange(file,1)}"
                        :before-upload="beforeUpload"
                        @preview="handlePreview"
                        list-type="picture-card"
                        name="file"
                >
                    <div v-if="fileList.length < 1">
                        <a-icon type="plus" style="font-size: 20px"/>
<!--                        <div class="ant-upload-text">Upload</div>-->
                    </div>
                </a-upload>
                <a-modal :footer="null" :visible="previewVisible" @cancel="handleCancel">
                    <img :src="previewImage" alt="example" style="width: 100%"/>
                </a-modal>
            </a-form-model-item>
          </template>
<!--            <a-form-model-item-->
<!--                    ref="hover_picture"-->
<!--                    label="划过图片"-->
<!--                    prop="hover_picture"-->
<!--                    :extra="formErr.hover_picture"-->
<!--                    :validateStatus='!formErr.hover_picture||formErr.hover_picture==""?"":"error"'-->
<!--            >-->
<!--                <a-upload-->
<!--                        :action="this.$store.state.urlChang"-->
<!--                        :data="{type:3}"-->
<!--                        :file-list="fileListSmall"-->
<!--                        :headers="headers"-->
<!--                        @change="(file)=>{handleChange(file,2)}"-->
<!--                        :before-upload="beforeUpload"-->
<!--                        @preview="handlePreview"-->
<!--                        list-type="picture-card"-->
<!--                        name="file"-->
<!--                >-->
<!--                    <div v-if="fileListSmall.length < 1">-->
<!--                        <a-icon type="plus"/>-->
<!--                        <div class="ant-upload-text">Upload</div>-->
<!--                    </div>-->
<!--                </a-upload>-->
<!--                <a-modal :footer="null" :visible="previewVisible" @cancel="handleCancel">-->
<!--                    <img :src="previewImage" alt="example" style="width: 100%"/>-->
<!--                </a-modal>-->
<!--            </a-form-model-item>-->
          <a-form-model-item label="模板编号" v-if="form.source==2">
            {{form.template_code}}
          </a-form-model-item>
          <a-form-model-item
              ref="status"
              label="状态"
              prop="status"
              :extra="formErr.status"
              :validateStatus='!formErr.status||formErr.status==""?"":"error"'
          >
            <a-radio-group v-model="form.status"  >
              <a-radio :value="item.id" :key="item.id" v-for="(item,index) in status_list"> {{item.name}}  </a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item
              ref="user_display"
              label="用户展示"
              prop="user_display"
              :extra="formErr.user_display"
              :validateStatus='!formErr.user_display||formErr.user_display==""?"":"error"'
          >
            <a-radio-group v-model="form.user_display"  >
              <a-radio :value="item.id" :key="item.id"  v-for="(item,index) in user_display_list"> {{item.name}} </a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item
              ref="abstract"
              label="介绍"
              prop="abstract"
              :help="formErr.abstract"
              :validateStatus='!formErr.abstract||formErr.abstract==""?"":"error"'
          >
            <a-input
                     type="textarea"
                     v-model="form.abstract"
                     @change="(e) => { formErr.abstract=''}"
                     @blur="(e) => {  form.abstract = e.target.value.trim(); }"
            />
          </a-form-model-item>




        </a-form-model>
        <div class="drawer-btn"  >

            <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">
                确定
            </a-button>
            <a-button @click="onClose">
            取消
        </a-button>
        </div>
    </a-drawer></div>
</template>

<script>
import {submitForm, drawerConfig, validator, beforeUpload, createUrl} from "../../../../utils/utils"
    import API from "../api";
    function getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    export default {
        name: "templateForm",
        props: ["visible","title","editId"],
        data() {
            return {fieldNames: {label: 'name', value: 'id', children: 'children'},
                drawerConfig ,
              category_list:[],
              source_list:[],
              status_list:[],
              user_display_list:[],
                fileList:[],
                fileListSmall:[],
                previewVisible: false,
                previewImage: "",
                headers: {Authorization: window.sessionStorage.getItem("signature")},
                form: {
                  a_ksh_module_category_id:"",
                  name:'',
                  option:'',
                  picture:'',
                  code_name:"",
                  source:1,
                  status:3,
                  user_display:1,
                  abstract:''
                },
                formErr: {
                  a_ksh_module_category_id:"",
                  name:'',
                  option:'',
                  picture:'',
                  code_name:"",
                  source:'',
                  status:'',
                  user_display:'',
                  abstract:''
                },
            // {required: true, message: "请输入首页内容", trigger: "blur"},{ whitespace: true, message: "请输入首页内容 " },
            rules: {
              a_ksh_module_category_id: [{required: true, message: "请选择分类", trigger: "blur"} ,{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.a_ksh_module_category_id)}  , trigger: "blur"  },],
              name:[{required: true, message: "请输入模块名称", },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.name)}  , trigger: "blur"  },],
              picture:[{required: true, message: " ",  }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.picture)}  , trigger: "blur"  },],

            },
                layout: {
                    labelCol: { span:6},
                    wrapperCol: { span: 14 },
                },
            };



        },
        watch:{
            editId: function (a, b) {
                if (a != "") {
                    API.service.EDIT_DATA(a).then(res => {
                        this.form = res.data.data.info
                        if (this.form.picture == "") {
                            this.fileList = []
                        } else {
                            this.fileList = [
                                {uid: this.form.picture,
                                 name: this.form.picture,
                                 status: "done",
                                 url: this.form.picture ? this.form.picture : ""
                                }
                            ]
                        }
                      this.category_list=res.data.data.category_list
                      this.status_list=res.data.data.status_list
                      this.source_list=res.data.data.source_list
                      this.user_display_list = res.data.data.user_display_list

                        this.form.id=a
                    })
                } else {

                  API.service.ADD_DATA(a).then(res => {
                    this.category_list=res.data.data.category_list
                    this.status_list=res.data.data.status_list
                    this.source_list=res.data.data.source_list
                    this.user_display_list = res.data.data.user_display_list
                    this.form.id = ''
                  })
                }
            }
        },
        mounted(){
            this.getFormData()
        },
        methods: {
  changeSource(val){
    console.log('val',val.target.value)
  },
            getFormData(){
                API.service.ADD_DATA().then(res => {
                    this.seleList=res.data.data
                })
            },
            handleCancel() {
                this.previewVisible = false;
            },
            handleChange(info ,type) {
                // alert(type)
                let {fileList} = info;
                const status = info.file.status;
                if (status !== 'uploading') {
                    type==1?this.fileList=[]:this.fileListSmall=[]
                }
                if (status === 'done') {
                    type==1?this.fileList=fileList:this.fileListSmall=fileList
                    // this.fileList= fileList
                } else if (status === 'error') {
                }
                if (status === 'uploading') {
                    type==1?this.fileList=fileList:this.fileListSmall=fileList
                    // this.fileList= fileList
                }
                if (status=== 'done') {
                    getBase64(info.file.originFileObj, imageUrl => {
                        // this.formErr.thumb=""
                        // this.fileList= fileList
                    });
                    if(type==1){
                        this.formErr.picture=""
                    }else {
                        this.formErr.hover_picture=""
                    }
                    type==1?this.fileList=fileList:this.fileListSmall=fileList
                }
                //重新设置state
                // this.setState( {fileList});
            },
            beforeUpload(file) {
                return beforeUpload(file,2)
            },
            async handlePreview(file) {
                if (!file.url && !file.preview) {
                    file.preview = await getBase64(file.originFileObj);
                }
                this.previewImage = file.url || file.preview;
                this.previewVisible = true;
            },
            onClose() {
                this.$emit("changVisible", false);
                this.fileList=[]
                this.fileListSmall=[],
                this.formErr={
                  a_ksh_module_category_id:"",
                  name:'',
                  option:'',
                  picture:'',
                  code_name:"",
                  source:'',
                  status:'',
                }

                this.$refs.ruleForm.resetFields();
            },
            onSubmit() {
                let _this = this;
                if(this.form.source==1||(this.form.source==2&&this.form.id)){
                  if (this.fileList.length < 1) {
                    _this.formErr.picture = "请选择图片";
                    return
                  } else {
                    _this.formErr.picture = "";
                    this.form.picture = this.fileList[0].url
                  }
                  if (this.fileList.length > 0 && this.fileList[0].url) {
                    this.form.picture = this.fileList[0].url
                  } else if (this.fileList.length > 0 && this.fileList[0].response) {
                    this.form.picture = this.fileList[0].response.data.url
                  } else {
                    this.form.picture = ""
                  }
                }

                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        let url
                        this.form.id == '' || this.form.id == undefined ? url = API.service.SUBMIT_ADD : url = API.service.SUBMIT_EDIT
                        submitForm(url, _this.form).then(res => {
                          if (res == true) {
                            this.onClose()
                            // if(url !== API.service.SUBMIT_ADD){
                            //   window.open(createUrl(window.tempData.ksh_token),'_blank')
                            // }
                          } else {
                                res.map((item, index) => {
                                    this.formErr[item.field] = item.msg
                                })
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        },
    }
</script>

<style scoped>
.ant-input-number-input{width: 100%!important;}
.ant-input-number{width: 100%!important;}
.box >>> .ant-form-extra{top:calc(100% - 18px) !important;position: absolute}
.box >>> .ant-form-item-control-wrapper{position: relative}
.box >>> .ant-checkbox-wrapper + .ant-checkbox-wrapper{margin-left: 0}
/*.box >>> .ant-form-extra*/
.ant-upload-list-picture-card .ant-upload-list-item-thumbnail, .ant-upload-list-picture-card .ant-upload-list-item-thumbnail img{    max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;}
</style>
